<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="terms" [(showModal)]="showModal" [buttonLabels]=" { primary: 'Descargar PDF'} " (modalButtonClick)="toggleModal($event)">
    <p id="pdfText" [innerHtml]="terms.text"></p>
  </vcl-modal>
<h2 class="nuestros-productos-d" *ngIf="this.documentInfo != undefined">
    {{ this.documentInfo.firstname }} {{copyService.copies.detail_bonding}}
</h2>
<div *ngFor="let row of products">
    <div class="border">
        <div class="credit-target" [innerHTML]="copyService.copies.label_checkbox_cards"></div>
        
        <!-- sin cuota -->
        <div *ngIf="this.noShare">
            <div class="subTitle">{{copyService.copies.detail_bonding_no_quota}}</div>
        <p class="credit-text">{{copyService.copies.detail_bonding_info_no_quota}}
        </p>
        <p class="credit-text">{{copyService.copies.detail_bonding_info_transactions}}</p>
        </div>
        
        <div class="characters">
            <voxel-icon class="icon">
                inovacao_outline
            </voxel-icon>
            <label class="label">
                {{copyService.copies.detail_bonding_card_features}}
            </label>
            <voxel-icon (click)="showMore()" Class="arrow">
                {{showIcon()}}
            </voxel-icon>
        </div>
        <hr>

        <div class="showMore" *ngIf="this.showMor">
            <div *ngFor="let card of cards">
                <h3 class="money">$6.000.000</h3>
                <h4 class="type-card">{{copyService.copies.detail_bonding_total_quota}}</h4>
                <img src="" alt="FRANQUICIAIMAGEN">
                <h4 class="type-card">{{copyService.copies.detail_bonding_type_card}}</h4>
                <h4 class="text-card">Nombre quemado de la tarjeta</h4>
                <h4 class="type-card">{{copyService.copies.detail_bonding_virtual_card}}</h4>
                <p class="text-card">{{copyService.copies.detail_bonding_enabled_info}}</p>
                <h4 class="type-card">{{copyService.copies.detail_bonding_handling_fee}}</h4>
                <p class="text-card">{{copyService.copies.detail_bonding_monthly_transactions}} </p>
                <h4 class="type-card">{{copyService.copies.detail_bonding_date_pay}}</h4>
                <p class="text-card">Día 1 de cada mes</p>
                <p class="type-card">{{copyService.copies.detail_bonding_benefits}}</p>
            </div>
        <hr>

        </div>
        <!-- Usa y no pagues -->
        <div>
            <h4 class="subTitle">{{copyService.copies.detail_bonding_use_no_pay}}</h4>
            <p class="credit-text">{{copyService.copies.detail_bonding_info_use_no_pay}}</p>
            <p class="credit-text">{{copyService.copies.detail_bonding_transactions_apply}}</p>
        </div>

    </div>
</div>
<br>
<div class="terms">
    <voxel-checkbox [id]="'checkboxTermsId'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked"
        name="terms" [value]="" (checkboxChange)="checkboxChange($event)"></voxel-checkbox>
    <div class="link">
        <vcl-link [label]="copyService.copies.detail_account_creation_link_label_tc"></vcl-link>
    </div>
</div>
<app-controls id="button-process" [hasPrevious]="true"
    [nextLabel]="copyService.copies.product_selection_go_step_process" [nextDisabled]="!statusValidation"
    (next)="next()"></app-controls>